var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestResetPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1033",
    "data-name": "Group 1033",
    transform: "translate(-137 -132)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 50.5,
    cy: 50.5,
    r: 50.5,
    transform: "translate(137 132)",
    fill: "#ffcc2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-key",
    "data-name": "Icon awesome-key",
    d: "M42.8,14.712A14.72,14.72,0,0,1,25.343,29.168C22.955,31.855,11.369,42.8,11.369,42.8H2.006A2.006,2.006,0,0,1,0,40.793V34.268a2.007,2.007,0,0,1,.588-1.419L14.113,19.324A14.714,14.714,0,1,1,42.8,14.712Zm-16.99-1.734a4.012,4.012,0,1,0,4.012-4.012A4.012,4.012,0,0,0,25.809,12.978Z",
    transform: "translate(166.5 160.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestResetPassword);
export default __webpack_public_path__ + "static/media/RequestResetPassword.01bd51eb99dfacad5c7de12ac6aea6e6.svg";
export { ForwardRef as ReactComponent };